import { Router } from '@angular/router';
import { OrgSettingsService } from '@app/orgs/services';
import { TargetsService } from '@app/target/services/targets.service';
import {
  BrandingService,
  ContextService,
  LDFlagsService,
  TrackerService,
  WebEnvironmentService,
} from '@degreed/lxp/services';
import { AuthService } from '@degreed/lxp/services/authorization';
import { TranslateService } from '@ngx-translate/core';
import { OrgHelpMenuService } from '../orgs/services/org-help-menu.service';

import { APOLLO_LAYOUT_TOKEN } from './layout.token';
import { buildLayoutConfiguration_v3 } from './v3';

import { NotificationService } from '@app/notifications/notification.service';

/**
 * Provider for Apollo Layouts v3
 * Used for the Apollo Navigation configuration
 */
export const ApolloLayoutProvider = {
  provide: APOLLO_LAYOUT_TOKEN,
  useFactory: buildLayoutConfiguration_v3,
  deps: [
    AuthService,
    TranslateService,
    WebEnvironmentService,
    TargetsService,
    LDFlagsService,
    ContextService,
    OrgHelpMenuService,
    TrackerService,
    BrandingService,
    NotificationService,
    OrgSettingsService,
    Router,
  ],
};
